import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  fetchHistoryFail,
  fetchHistorySuccess,
  FETCH_HISTORY
} from '../../redux/actions/cm/caseHistory';
import { fetchHistoryForCase } from '../../services/cm/historyItems';

function* fetchHistoryWorker({ caseId, currentHistoryPage }) {
  try {
    const { items: list, total } = yield call(fetchHistoryForCase, {
      caseId,
      currentHistoryPage
    });
    yield put(fetchHistorySuccess({ list, total }));
  } catch (error) {
    yield put(fetchHistoryFail());
  }
}

export function* watchfetchHistory() {
  yield takeEvery(
    FETCH_HISTORY,
    function* ({ payload: { caseId, currentHistoryPage } }) {
      yield fork(fetchHistoryWorker, { caseId, currentHistoryPage });
    }
  );
}
